import React, { useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../utils/axios-instance";
import useAuth from "../../stores/authStore";

export default function ClientDeliveryRoomCard({
  room,
  theme,
  onOpen,
  onArchived,
  onActivated,
}) {
  const profileData = useAuth((state) => state.profileData);
  const [togglingStatus, setTogglingStatus] = useState(false);

  const canArchiveRoom =
    profileData?.role_priv === "org_admin" ||
    profileData?.role_priv === "super_admin";

  const isArchived = Boolean(
    room.isArchived ||
      room.archived ||
      room.roomStatus === "archived" ||
      room.status === "Archived"
  );

  const handleToggleStatus = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (togglingStatus) return;

    const action = isArchived ? "activate" : "archive";
    const confirmMessage = isArchived
      ? `Activate the delivery room for "${room.clientName}"?`
      : `Archive the delivery room for "${room.clientName}"?`;
    if (!window.confirm(confirmMessage)) return;

    setTogglingStatus(true);
    try {
      await api.post(`/vendors/rooms/${room.id}/${action}/`);
      toast.success(
        isArchived ? "Delivery room activated" : "Delivery room archived"
      );
      if (isArchived) {
        onActivated?.(room.id);
      } else {
        onArchived?.(room.id);
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error || `Failed to ${action} delivery room`
      );
    } finally {
      setTogglingStatus(false);
    }
  };

  return (
    <div
      onClick={() => onOpen(room)}
      style={{
        background: theme.cardBg,
        border: `1px solid ${theme.border}`,
        borderRadius: "12px",
        padding: "24px",
        position: "relative",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        transition: "transform 0.2s",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "16px",
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: theme.textMain,
              margin: "0 0 4px 0",
            }}
          >
            {room.clientName}
          </h3>
          <p
            style={{
              fontSize: "13px",
              color: theme.textSub,
              margin: 0,
            }}
          >
            {room.projectName}
          </p>
        </div>
        <span
          className={
            isArchived
              ? "bg-red-100 text-red-800"
              : "bg-green-100 text-green-800"
          }
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "11px",
            fontWeight: "600",
          }}
        >
          {isArchived ? "Archived" : "Active"}
        </span>
      </div>

      <div
        style={{
          marginTop: "auto",
          borderTop: `1px solid ${theme.border}`,
          paddingTop: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "12px",
          color: theme.textSub,
        }}
      >
        <span>
          {room.deliverablesCount || 0} deliverables · Payment: Not activated
        </span>
        {canArchiveRoom && isArchived && (
          <button
            type="button"
            onClick={(e) => handleToggleStatus(e)}
            disabled={togglingStatus}
            style={{
              background: "transparent",
              border: `1px solid ${theme.border}`,
              color: "#137333",
              padding: "4px 10px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: "600",
              cursor: togglingStatus ? "default" : "pointer",
            }}
          >
            {togglingStatus ? "Activating..." : "Activate"}
          </button>
        )}
        {canArchiveRoom && !isArchived && (
          <button
            type="button"
            onClick={(e) => handleToggleStatus(e)}
            disabled={togglingStatus}
            style={{
              background: "transparent",
              border: `1px solid ${theme.border}`,
              color: "#c5221f",
              padding: "4px 10px",
              borderRadius: "4px",
              fontSize: "11px",
              fontWeight: "600",
              cursor: togglingStatus ? "default" : "pointer",
            }}
          >
            {togglingStatus ? "Archiving..." : "Archive"}
          </button>
        )}
      </div>
    </div>
  );
}
